export default __webpack_public_path__ + "static/media/arm-left-front.bc81a01b.png";